import Axios from 'axios'
import _ from 'lodash'
import { authHeader } from '../helpers/authHeader'
import { clearActiveAccessToken, clearRefreshTokenAndSession } from '../helpers/AuthorizationHelpers'
import { axios } from '../helpers/axios'

const CancelToken = Axios.CancelToken

export function requestHeader(requiresAuthentication, aditionalheaders = {}) {
  const header = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  }
  if (requiresAuthentication) {
    const authorization = authHeader()
    Object.assign(header, authorization)
  } else {
    Object.assign(header, { Public: true })
  }
  return {
    headers: {
      ...header,
      ...aditionalheaders,
    },
  }
}

export function getRequest(
  apiEndpoint,
  data = null,
  requiresAuthentication = true,
  onFulfilled = null,
  cancelRequest = null,
) {
  const requestOptions = requestHeader(requiresAuthentication)
  if (data !== null) {
    Object.assign(requestOptions, { params: data })
  }
  if (cancelRequest) {
    Object.assign(requestOptions, {
      cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancelRequest = c
      }),
    })
  }
  return axios.get(`api/${apiEndpoint}`, requestOptions).then(handleSuccess).then(onFulfilled).catch(handleError)
}

export function postRequest(
  apiEndpoint,
  data = null,
  requiresAuthentication = true,
  stringify = true,
  onFulfilled = undefined,
  headers = undefined,
) {
  const requestOptions = requestHeader(requiresAuthentication, headers)
  const postData = stringify ? JSON.stringify(data) : data
  return axios
    .post(`api/${apiEndpoint}`, postData, requestOptions)
    .then(handleSuccess)
    .then(onFulfilled)
    .catch(handleError)
}

export function patchRequest(
  apiEndpoint,
  data = null,
  requiresAuthentication = true,
  stringify = true,
  onFulfilled = null,
) {
  const requestOptions = requestHeader(requiresAuthentication)
  const patchData = stringify ? JSON.stringify(data) : data

  return axios
    .patch(`api/${apiEndpoint}`, patchData, requestOptions)
    .then(handleSuccess)
    .then(onFulfilled)
    .catch(handleError)
}

export function deleteRequest(apiEndpoint, requiresAuthentication = true, onFulfilled = null) {
  const requestOptions = requestHeader(requiresAuthentication)

  return axios.delete(`api/${apiEndpoint}`, requestOptions).then(handleSuccess).then(onFulfilled).catch(handleError)
}

export function handleSuccess(response) {
  const data = response.data
  return JSON.parse(JSON.stringify(data))
}

export function handleError(error) {
  const data = _.get(error, 'response.data', '')
  const text = JSON.parse(JSON.stringify(data))
  if (error.response) {
    if (error.response.status === 401) {
      localStorage.removeItem('user')
      localStorage.setItem('sessionMsg', 'Du ble utlogget. Sesjonen kan være utløpt. Prøv å logg inn på nytt.')
      window.location.reload()
    }

    if (error.response.status === 400) {
      return Promise.reject({
        text: text,
        responseCode: error.response.status,
      })
    } else {
      return Promise.reject(text)
    }
  } else {
    return text
  }
}

export async function logout() {
  // remove user from local storage to log user out
  await clearRefreshTokenAndSession()
  clearActiveAccessToken()
}

if (window.Cypress) {
  // @ts-ignore
  window.logout = async () => {
    await logout()
    window.location.replace('/login')
  }
}
